import React from 'react';

interface UserIconProps {
  username: string;
  size?: number;
  backgroundColor?: string;
}

const UserIcon: React.FC<UserIconProps> = ({ username, size = 40, backgroundColor }) => {
  const firstLetter = username.charAt(0).toUpperCase();
  
  // Generate a consistent color based on the username
  const generateColor = (str: string) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash % 360);
    return `hsl(${hue}, 70%, 50%)`; // Using HSL for better color distribution
  };

  const bgColor = backgroundColor || generateColor(username);

  // Use only inline styles for compatibility with renderToString
  const iconStyle: React.CSSProperties = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    maxWidth: size,
    maxHeight: size,
    borderRadius: '50%',
    backgroundColor: bgColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontWeight: 'bold',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    fontSize: size * 0.4,
    textShadow: '0 1px 2px rgba(0,0,0,0.2)',
    userSelect: 'none',
    overflow: 'hidden',
  };
  // If the icon still appears squished, check parent container styles for flex/grid constraints or aspect ratio issues.

  return (
    <div style={iconStyle}>
      {firstLetter}
    </div>
  );
};

export default UserIcon; 